export const uppercase = (value: string): string => {
  return value[0].toUpperCase() + value.slice(1);
};

// the fast-xml-parser plugin will return the primitive value despite what you have defined in the interface.
// you need call this helper if the defined returne is a string but the actual return is another primitive type

export const removeLeadingCharacters = (input: string, char: string): string => {
  while (input.charAt(0) === char) {
    input = input.substr(1);
  }
  return input;
};

export const getValueAsString = (input?: number | string | boolean): string => {
  switch (typeof input) {
    case 'number':
      return converNumberToString(input);
    case 'boolean':
      return converBooleanToString(input);
    case 'undefined':
      return '';
    default:
      return input;
  }
};

const converNumberToString = (input: number): string => {
  return input.toString();
};

const converBooleanToString = (input: boolean): string => {
  return input.toString();
};

export const normalizeLength = (value: string, maxLength: number): string => {
  if (value.length > maxLength) {
    return `${value.substring(0, maxLength)} ...`;
  }
  return value;
};

export const formatString = (value: string, ...params: string[]): string => {
  for (let index = 0; index < params.length; index++) {
    value = value.replace(`{${index}}`, params[index]);
  }
  return value;
};

export const splitCamel = (description?: string, delimiter: string = ' '): string | undefined => {
  if (description) {
    return description
      .split(/(?<!(^|[A-Z]))(?=[A-Z])|(?<!^)(?=[A-Z][a-z])/)
      .filter(word => !!word)
      .join(delimiter);
  }
};
